
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { UserModule } from "@/store/modules/user";
import { ViewType } from "@/types/orderServicer";
import {
  checkPermissionCompanyFromOrderType,
  checkPermissionCompany,
  checkPermissionRole,
  checkPermissionUseAndCompany,
} from "@/utils/permission";
import { Type } from "@/types/permissionType";
import { EditDialog } from "@/types/editDialogType";
import { isFinish, bottomBtnOrderState } from "@/utils/orderStatsUtils";
import BbsDialog from "@/components/BbsDialog/index.vue";
import editDialog from "@/components/EditDialog/index.vue";
import supplementProgressDialog from "@/components/SupplementProgressDialog/index.vue";
// import DrawerDetail from '@/components/Drawer/DrawerDetail.vue';

import {
  orderServiceOrderHang,
  orderServiceOrderClose,
  orderGrab,
  delOrderService,
  sendBack,
  recover,
  chargePrice,
  getOrderDetail,
  getOrderDispose,
} from "@/api/orderService";
import { chargeOffList, batchChargeOff } from "@/api/stock";

@Component({
  name: "BtnGroup2",
  components: {
    BbsDialog,
    editDialog,
    supplementProgressDialog,
    // DrawerDetail
  },
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
    required: true,
  })
  orderDetail!: any;

  @Prop({
    default: ViewType.ORDER_SERVICER,
    validator: (value: any) => ViewType[value] !== undefined,
  })
  private viewType?: ViewType;
  @Prop({
    default: false,
    type: Boolean,
  })
  private isSendEng!: boolean;
  @Watch("orderDetail", {
    deep: true,
    immediate: true,
  })
  handleChangeProps() {
    this.isFinish = isFinish(
      parseInt((this.orderDetail as any).order_service.state)
    );
    this.orderState = bottomBtnOrderState(
      parseInt((this.orderDetail as any).order_service.state)
    );
  }

  private permissionType = Type;
  private isFinish = false;
  private orderState = 0;

  private nowId: number = -1;
  private nowSid: number = -1;
  private bbsDialogVisible: boolean = false;
  private chargeOffDialogVisible: boolean = false;
  private priceVisible: boolean = false;
  private supplementProgressDialogVisible: boolean = false;
  private chargeOffLoading: boolean = false;
  private chargeOffTableList: any = [];
  // 不根据state判断，所以永远置为1
  private state: number = 1;

  private editDialogData: any = {
    visible: false,
    title: "",
    name: "",
    inputValue: "",
    inputHint: "",
    cancel: "",
    confirm: "",
    callBack: "",
    rules: [],
  };

  private addPirceCustomer = "0";
  private addPirceSS = "";

  private confirmButton = false;
  private isTransferOut = false;
  private companyId = "";
  private tabList: any = [];
  private orderServiceId = "";
  private tabId = {
    id: "",
    companyId: "",
  };

  created() {}
  private deptVisible = false;
  private dept: any = {};
  private deptList: any = [];
  private glOrderDetail: any = {};
  private grabOrderHandle(row: any) {
    this.glOrderDetail = row;
    this.deptList = UserModule.getUserDeptList;
    this.dept = {};
    if (this.deptList) {
      this.deptList = this.deptList.filter((item: any) => {
        return parseInt(item.dept_type) === 2;
      });
    }
    if (!this.deptList || this.deptList.length < 1) {
      this.deptConfirm();
      return;
    }
    if (this.deptList && this.deptList.length === 1) {
      this.dept = this.deptList[0];
      this.deptConfirm();
      return;
    }
    this.deptVisible = true;
  }
  private deptConfirm() {
    let that = this;
    let parmars: any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.user_name = UserModule.getUserName;
    parmars.company_id = UserModule.getCompanyId;
    parmars.order_service_id = this.glOrderDetail.order_service.id;
    parmars.grab_user_id = UserModule.getUserId;
    parmars.grab_user_name = UserModule.getUserName;
    if (this.dept && this.dept.id) {
      parmars.grab_dept_id = this.dept.id;
      parmars.grab_dept_name = this.dept.name;
    }
    orderGrab(parmars)
      .then((res: any) => {
        if (res.data) {
          this.$confirm("接单成功，是否立即处理？", "", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then((val) => {
              this.$nextTick(() => {
                that.$router.push({
                  path: "/Task/todealing",
                  query: {
                    taskId: res.data.order_task.id,
                    companyId: res.data.order_task.company_id,
                    orderType: that.glOrderDetail.order.order_type,
                    enterType: "1",
                  },
                });
              });

              that.$emit("refreshList", true);
            })
            .catch(() => {
              this.deptVisible = false;
              that.$emit("refreshList", true);
            });
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  dealHandle(row: any) {
    this.$router.push({
      path: "/OrderServicer/todealing",
      query: {
        order_service_id: row.order_service.id,
        company_id: row.order_service.servicer_company_id,
      },
    });
  }

  // 补充进度
  supplementProgress() {
    this.supplementProgressDialogVisible = true;
  }

  SupplementProgressDialogClose() {
    this.supplementProgressDialogVisible = false;
  }

  // 挂单弹窗
  handUp(r: any) {
    this.editDialogData = {
      visible: true,
      title: "挂单原因",
      name: "备注",
      inputValue: "",
      inputHint: "请填写挂单原因",
      cancel: "取消",
      confirm: "确定",
      callBack: "handUpCallBack",
      rules: [{ required: true, message: "请填写备注", trigger: "blur" }],
    };
  }

  // 挂单返回监听
  handUpCallBack(editDialogData: EditDialog) {
    if (!editDialogData.inputValue.trim()) {
      this.showSuccessMsg("请填写挂单原因");
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      order_service_id: (this.orderDetail as any).order_service.id,
      remark: editDialogData.inputValue,
    };
    orderServiceOrderHang(params)
      .then((res: any) => {
        editDialogData.visible = false;
        this.showSuccessMsg("挂单成功");
        this.$emit("refreshList", true);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 退回
  private backOrderCallback(editDialogData: EditDialog) {
    
    if (!editDialogData.inputValue.trim()) {
      this.showSuccessMsg("请填写退回原因");
      return;
    }
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName,
      order_service_id: (this.orderDetail as any).order_service.id,
      remark: editDialogData.inputValue,
    };
    // pamars.order_service_id = r.order_service.id;
    sendBack(pamars)
      .then((res: any) => {
        this.showSuccessMsg(res.msg);
        this.$emit("refreshList", true);
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 退单弹窗
  backOrderDialog(r: any) {
    this.editDialogData = {
      visible: true,
      title: "退回原因",
      name: "备注",
      inputValue: "",
      inputHint: "请填写退回原因",
      cancel: "取消",
      confirm: "确定",
      callBack: "backOrderCallback",
      rules: [{ required: true, message: "请填写备注", trigger: "blur" }],
    };
  }

  // 删除
  private delOrder(r: any) {
    this.$confirm("关联任务会一起删除呦~", "确认删除此订单?", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let pamars: any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId,
          company_name: UserModule.getCompanyName,
        };
        pamars.order_service_id = r.order_service.id;
        delOrderService(pamars)
          .then((res: any) => {
            this.showSuccessMsg(res.msg);
            this.$emit("refreshList", true);
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  private closeChargeOffDialog() {
    this.chargeOffDialogVisible = false;
  }

  private chargeOffOrderInfo: any = {};

  // 核销
  private chargeOff(r: any) {
    this.chargeOffLoading = true;
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.is_charge_off = "0";
    params.order_num = r.order.order_num;
    chargeOffList(params)
      .then((res) => {
        this.chargeOffLoading = false;
        this.chargeOffDialogVisible = true;
        if (res.data && res.data.list && res.data.list[0].parts) {
          this.chargeOffOrderInfo = res.data.list[0];
          this.chargeOffTableList = res.data.list[0].parts;
        } else {
          this.chargeOffTableList = [];
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }

  private chargeOfffinishDialogHandle() {
    let _ = this;
    let arr: any = [];
    if (this.chargeOffTableList && this.chargeOffTableList.length > 0) {
      this.chargeOffTableList.map(function(item: any) {
        let t = _.getData(item, _.chargeOffOrderInfo);
        arr.push(t);
      });
    }
    this.verify(arr);
  }

  // 组织单个核销的数据
  private getData(val: any, val2: any) {
    let temp: any = {};
    temp.stock_id = val.stock_id;
    temp.stock_name = val.parts_name;
    temp.model_id = val.stock_model_id;
    temp.model_name = val.parts_model_name;
    temp.serial_number = val.serial_number;
    temp.specification = val.specification;
    temp.image_save_path = val.image_save_path;
    temp.num = val.parts_amount;
    temp.inout_user_id = val.p_user_id;
    temp.inout_user_name = val.p_user_name;
    temp.order_parts_id = val.order_parts_id;
    temp.order_num = val2.order_num;
    if (parseInt(val2.customer_company_id) === 0) {
      temp.customer_user_id = val2.customer_user_id;
      temp.customer_user_name = val2.customer_user_name;
    } else {
      temp.customer_company_id = val2.customer_company_id;
      temp.customer_company_name = val2.customer_company_name;
    }
    return temp;
  }

  private verify(arr: any) {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.batch_data = JSON.stringify(arr);
    batchChargeOff(params)
      .then((res) => {
        this.showSuccessMsg("核销成功");
        this.closeChargeOffDialog();
        this.$emit("refreshList", true);
      })
      .catch((error) => {
        let msg = error.msg;
        this.showErrorMsg(msg);
      });
  }

  // 关单返回监听
  closeOrderCallBack(editDialogData: EditDialog) {
    if (!editDialogData.inputValue.trim()) {
      this.showSuccessMsg("请填写备注");
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      order_service_id: (this.orderDetail as any).order_service.id,
      remark: editDialogData.inputValue,
    };
    orderServiceOrderClose(params)
      .then((res: any) => {
        editDialogData.visible = false;
        this.showSuccessMsg("关闭成功");
        this.$emit("refreshList", true);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }
  // 关单弹窗
  closeOrder(r: any) {
    this.editDialogData = {
      visible: true,
      title: "关闭订单",
      name: "备注",
      inputValue: "",
      inputHint: "请填写备注",
      cancel: "取消",
      confirm: "确定",
      callBack: "closeOrderCallBack",
      rules: [{ required: true, message: "请填写备注", trigger: "blur" }],
    };
  }
  // 待客确认
  private confirmCustomer(row: any) {
    // order.order_type === "4" ? "服务完成" : "代客确认"
    this.$router.push({
      path: "/OrderServicer/todealing",
      query: {
        order_service_id: row.order_service.id,
        company_id: row.order_service.servicer_company_id,
        isFinshCustomer: "1",
      },
    });
  }

  // 添加金额
  addPrice(val: any) {
    this.priceVisible = true;
    this.addPirceCustomer = val.order_service.estimated_amount;
    this.addPirceSS = val.order_service.real_price;
  }

  addPriceConfirm() {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      id: (this.orderDetail as any).order_service.id,
      price: this.addPirceSS,
    };
    chargePrice(params)
      .then((res: any) => {
        this.priceVisible = false;
        this.showSuccessMsg("修改成功");
        this.$emit("refreshList", true);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  addPriceClose() {
    this.priceVisible = false;
  }
  // 回访
  private returnVisit(val: any) {
    this.$router.push({
      path: "/OrderServicer/returnvisit",
      query: { orderDetail: JSON.stringify(val) },
    });
  }

  // 工作单
  webWorkSheet(orderDetail: any) {
    // window.open(
    //   'http://user.baoxiuguanjia.com/OrderServicer/workSheet.html?id=' +
    //     orderDetail.order_service.id
    // );

    window.open(
      location.protocol +
        (process.env.NODE_ENV === "production"
          ? process.env.VUE_APP_BASE_API
          : process.env.VUE_APP_BASE_API_DEV) +
        "OrderService/workSheetDetail?company_id=" +
        UserModule.getCompanyId +
        "&user_id=" +
        UserModule.getUserId +
        "&user_name=" +
        UserModule.getUserName +
        "&company_name=" +
        UserModule.getCompanyName +
        "&order_service_id=" +
        orderDetail.order_service.id
    );
  }

  // 远程视频
  videoCall(r: any) {
    let routeData = this.$router.resolve({
      path: "/VideoCall",
      query: {
        order_id: (this.orderDetail as any).order.id,
        order_service_id: (this.orderDetail as any).order_service.id,
        company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
        user_id: UserModule.getUserId,
      },
    });
    window.open(routeData.href, "_blank");
  }

  videoCallClose() {}

  // 留言
  bbsHandle(r: any) {
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    this.bbsDialogVisible = true;
  }

  // 留言关闭
  closeBbs(value: boolean) {
    this.bbsDialogVisible = value;
  }

  private showDrawerDetails = false;
  private DetailsDataQuery: any = {};
  private closeDrawerDetail(val: boolean) {
    this.showDrawerDetails = val;
  }
  detailHandle(val: any) {
    let routeData = this.$router.resolve({
      path: "/OrderServicer/todetail",
      query: {
        order_service_id: val.order_service.id,
        company_id: val.order_service.servicer_company_id,
        viewType: this.viewType + "",
      },
    });
    window.open(routeData.href);

    // this.showDrawerDetails = true;
    // this.DetailsDataQuery = {
    //   order_service_id: val.order_service.id,
    //   company_id: val.order_service.servicer_company_id,
    //   viewType: this.viewType + ''
    // };
  }

  // 评价
  evaluateHandle(val: any) {
    let arr: any = [val];
    // 自定义评价
    if (
      parseInt(val.order_service.is_open_diy_evaluate) === 1 &&
      checkPermissionUseAndCompany(
        UserModule.getCompanyId,
        Type.OrderEvaluate
      )
    ) {
      this.$router.push({
        path: "/OrderServicer/evaluation",
        query: {
          orderList: JSON.stringify(arr),
        },
      });
    } else {
      this.$router.push({
        path: "/OrderServicer/evaluate",
        query: {
          orderList: JSON.stringify(arr),
        },
      });
    }
  }
  // 回收站恢复
  private resetHandle(r: any) {
    this.$confirm("关联任务会一起恢复到删除前的状态呦~", "确认恢复此订单?", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let pamars: any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId,
          company_name: UserModule.getCompanyName,
        };
        pamars.id = r.order_service.id;
        recover(pamars)
          .then((res: any) => {
            this.showSuccessMsg(res.msg);
            this.$emit("refreshList", true);
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  private checkPermissionCompanyFromOrderType(
    companyId: string,
    permission: Type,
    orderType: any
  ) {
    return checkPermissionCompanyFromOrderType(
      companyId,
      permission,
      orderType
    );
  }
  private checkPermissionUser(companyId: string, permission: Type) {
    return checkPermissionRole(companyId, permission);
  }
  private checkPermissionCompany(companyId: string, permission: Type) {
    return checkPermissionCompany(companyId, permission);
  }
  private checkPermissionUseAndCompany(companyId: string, permission: Type) {
    return checkPermissionUseAndCompany(companyId, permission);
  }

  private getOrderDetail(orderServiceId: string) {
    const params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.companyId,
      order_service_id: orderServiceId,
    };
    getOrderDetail(params)
      .then((res: any) => {
        if (res.data) {
          this.orderDetail = res.data;
        }
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private customHeight = window.innerHeight * 0.4;
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: this.customHeight,
      customClass: "notification-center",
      type: "success",
    });
  }
}
